const baseUrl = process.env.REACT_APP_API_URL;
window.baseUrl = baseUrl; 
export default baseUrl;

